export const domain = 'Register';
export const prefix = 'REGISTER::';
export const blockingTime = 30; // in seconds